module.exports = __webpack_public_path__ + "img/importPnExample.9ac8a96f.png";